export enum ActionType {
  /**************************************8****/
  /*                                         */
  /* GET ALL ADMIN NOTIFICATIONS ACTION TYPE */
  /*                                         */
  /*******************************************/

  GET_ALL_ADMIN_NOTIFICATIONS_REQUEST = 'get_all_admin_notifications_request',
  GET_ALL_ADMIN_NOTIFICATIONS_SUCCESS = 'get_all_admin_notifications_success',
  GET_ALL_ADMIN_NOTIFICATIONS_ERROR = 'get_all_admin_notifications_error'
}
